import { Form, FormInstance, Row } from "antd";
import { useGetInitialValues } from "../hooks/useGetInitialValues";
import { Loader } from "../../../../components/Loader";
import { NameFormItem } from "./NameFormItem";
import { DescFormItem } from "./DescFormItem";
import { useSave } from "../hooks/useSave";
import { UploadFileFormItem } from "../../../Account/components/View/Admin/Documents/components/UploadFileFormItem";
import { FormButtons } from "../../components/FormButtons";
import { useDelete } from "../hooks/useDelete";
import { VisibilityFormItem } from "./VisabilityFormItem";

type FormItemsProps = {
  id: string | null | undefined;
  close: () => void;
  reloadData: () => void;
};

export const FormItems = ({ id, close, reloadData }: FormItemsProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const { isLoading, itialValues } = useGetInitialValues(id, form);

  const { isFormDisabled, setIsFormDisabled, onSave } = useSave(
    form,
    id,
    reloadData,
    close,
  );

  const { onDelete } = useDelete(reloadData, close);

  return (
    <Row className="fee-form h-100 d-flex position-relative flex-column">
      {isLoading ? (
        <Loader fontSize="64" />
      ) : (
        <Form
          form={form}
          layout="vertical"
          requiredMark={false}
          className="pa-6"
          initialValues={itialValues}
          disabled={isFormDisabled}
        >
          <NameFormItem />

          <DescFormItem />

          <UploadFileFormItem
            setIsLoading={setIsFormDisabled}
            uploadType={5}
            label="Form"
            title="Upload PDF"
          />

          <VisibilityFormItem />
        </Form>
      )}
      <FormButtons
        currentId={id || null}
        onSaveClick={onSave}
        onCancelClick={close}
        onDeleteClick={onDelete}
        isFormDisabled={isFormDisabled}
        controller={"FillableFormTemplates"}
      />
    </Row>
  );
};
